import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	IconButton,
	Stack,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import { FC } from 'react';

interface IScheduleInfoModalProps {
	title?: string;
	description?: any;
	buttonText?: string;
	buttonOnClick?: () => void;
	open: boolean;
	handleClose: () => void;
}

const ScheduleInfoModal: FC<IScheduleInfoModalProps> = ({
	title,
	description,
	buttonText,
	buttonOnClick,
	open,
	handleClose,
}) => {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<>
			<Dialog open={open} onClose={handleClose}>
				<DialogContent>
					<Stack
						direction="column"
						sx={{ alignItems: 'center', textAlign: 'center', py: 3, position: 'relative' }}
					>
						{!isSmallScreen && (
							<IconButton
								onClick={handleClose}
								sx={{ position: 'absolute', right: '-10px', top: '-10px' }}
							>
								<CloseIcon />
							</IconButton>
						)}
						<ErrorIcon sx={{ width: 33, height: 33 }} />
						<Typography variant="header3" sx={{ color: 'text.primary', mt: 3, mb: 2 }}>
							{title}
						</Typography>
						{description && description()}
					</Stack>
				</DialogContent>
				<DialogActions
					sx={{
						py: 2,
						px: 4,
						backgroundColor: 'backgrounds.neutral',
						justifyContent: { md: 'center', xs: 'space-between' },
					}}
				>
					<Button variant="tertiaryDefault" onClick={buttonOnClick}>
						{buttonText}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default ScheduleInfoModal;
